import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// 다국어
import { useTranslation } from 'react-i18next';
// @mui
import { styled } from '@mui/material/styles';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';

const StyledSection = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  background:
    'linear-gradient(0deg, rgba(26, 158, 248, 0.5), rgba(26, 158, 248, 0.5)),linear-gradient(88.71deg, rgba(97, 26, 248, 0.8) 0%, rgba(109, 134, 199, 0.8) 30.71%, rgba(141, 187, 83, 0.64) 63.02%, rgba(0, 255, 117, 0.64) 100%);',
  borderBottom: '1px solid #ddd',
  textAlign: 'center',
  padding: '3rem',
  color: '#fff',
  '& h1': { fontWeight: '500' },
}));

const StyledSectionBottom = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-start',
  borderBottom: '1px solid #ddd',
  alignItems: 'center',
  backgroundColor: '#fff',
}));

const StyledSectionHome = styled('div')(() => ({
  borderLeft: '1px solid #ddd',
  borderRight: '1px solid #ddd',
  padding: '1rem',
  marginLeft: '10%',
  display: 'flex',
}));

const StyledSectiontitle = styled('div')(() => ({
  borderRight: '1px solid #ddd',
  padding: '1rem',
  width: '14rem',
}));

const StyledSectionExtra = styled('div')(() => ({
  borderRight: '1px solid #ddd',
  padding: '1rem',
  width: '14rem',
}));

const StyledSelect = styled(Select)(() => ({
  borderRight: '1px solid #ddd',
  borderRadius: 0,
  width: '14rem',
  '& fieldset': {
    border: 'none',
  },
}));

export default function PageHeader({ data, setBoardListType }) {
  // 다국어
  const { t, i18n } = useTranslation(['page']);

  const navigate = useNavigate();
  const [title, setTitle] = React.useState('');
  const [List, setList] = React.useState([]);

  const [veiwCategory, setVeiwCategory] = useState(1);
  const [viewPost, setViewPost] = useState(true);

  const [userLogin, setUserLogin] = useState(false);
  const [none, setNone] = useState(false);

  const handleChange = (event) => {
    setTitle(event.target.value);
    setBoardListType(event.target.value);
    console.log(event.target.value);
  };

  const list1 = [t('문의하기')];

  const list2 = [t('대시보드')];

  const list3 = ['설치가이드', '프로그램 이용가이드'];

  const list4 = ['라이센스 정책', '프로그램 소개'];

  const list5 = [t('레인드롭'), t('슈가폴')];

  React.useEffect(() => {
    switch (data) {
      case '문의하기':
        setNone(true);
        break;

      case '마이페이지':
        if (sessionStorage.getItem('login_info') !== '' || sessionStorage.getItem('login_info') !== null) {
          setUserLogin(true);
        }
        setNone(true);
        break;

      case '이용안내':
        // setTitle(list3[0]);
        //  setList(list3);
        setNone(true);
        break;

      case '제품소개':
        setTitle(list4[0]);
        setList(list4);
        break;

      default:
        setNone(true);
        break;
    }

    // if(!userLogin){
    //   navigate('/login', { replace: true })

    // }
  }, []);

  return (
    <>
      <StyledSection>
        <h1>{t(data)}</h1>
      </StyledSection>
      <StyledSectionBottom>
        <StyledSectionHome>
          <HomeRoundedIcon />
        </StyledSectionHome>
        <StyledSectiontitle>{t(data)}</StyledSectiontitle>

        {none === false ? (
          <StyledSelect
            value={title}
            onChange={handleChange}
            displayEmpty
            inputProps={{ 'aria-label': 'Without label' }}
          >
            {List.map((value) => (
              <MenuItem key={value} value={value}>
                {value}
              </MenuItem>
            ))}
          </StyledSelect>
        ) : null}
      </StyledSectionBottom>
      {/* <ViewPost data={veiwCategory} />  */}

      {/* {data === '제품소개' && <MypageDashBoard data={pageTab} />}
            {data === '이용안내' && <SetProgile data={pageTab} />}
            {data === '공지사항' && <LicenseManage data={pageTab} />}
            {data === '커뮤니티' && <LicenseManage data={pageTab} />} */}
    </>
  );
}
